export const title = 'Departments';
export const subtitle =
  'Sort your employees and group them by departments, events or any other teams.';
export const learn_more = 'Learn more';

export const add_department_button = 'Add Department';
export const add_department_title = 'Add a Department';
export const add_department_name_field = 'Department Name*';

export const upload_departments_button = 'Upload Departments';
export const edit_department_button = 'Edit';
export const edit_department_header = 'Edit department';
export const edit_department_name_field = 'Department Name*';

export const right_drawer_button_save = 'Save';
export const right_drawer_button_save_and_continue = 'Save and add another';

export const delete_department_button = 'Delete';
export const delete_department_dialog_return_button = 'Back to Departments';

export const delete_department_dialog_employee_title =
  'Remove employees in the department first';
export const delete_department_dialog_employee_subtitle =
  'To delete this department, please remove all employees from this department under Company > Employees.';
export const delete_department_dialog_employee_button = 'Manage Employees';

export const delete_department_dialog_confirmation_title = 'Delete';
export const delete_department_dialog_confirmation_subtitle =
  'Deleting this department might affect the allowances and subscriptions linked to it. Delete anyway?';
export const delete_department_dialog_confirmation_button = 'Delete';

export const department_table_header_one = 'Department ID';
export const department_table_header_two = 'Department';
export const department_table_header_three = 'No. of Employees';

export const empty_page_title = 'Manage employees by departments';
export const empty_page_subtitle =
  'Filter by departments to manage expenses and benefits at one go!';

export enum Actions {
  Add = 'add',
  Edit = 'edit',
  Delete = 'delete'
}
